import React from 'react';
import cc from 'classcat';

type ButtonColor = 'primary' | 'success' | 'error' | 'gray' | 'blue' | 'white';
type ButtonVariant = 'contained' | 'outlined' | 'text' | 'bordered';

interface IIconButtonWithText {
    text: string;
    iconSrc?: string;
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
    className?: string;
    isSubmit?: boolean;
    disabled?: boolean;
    textColour?: ButtonColor;
    iconAlt?: string;
    variant?: ButtonVariant;
}

export const IconButtonWithText = ({
    className,
    onClick,
    text,
    isSubmit,
    disabled,
    iconSrc,
    textColour = 'primary',
    iconAlt,
    variant = 'contained',
}: IIconButtonWithText) => {
    return (
        <button
            type={isSubmit ? 'submit' : 'button'}
            onClick={onClick}
            disabled={disabled}
            className={cc([
                'icon-button-with-text',
                `icon-button-with-text--${variant}`,
                `icon-button-with-text--${variant}--${textColour}`,
                className,
            ])}
        >
            {iconSrc && <img src={iconSrc} alt={iconAlt} />}
            <span>{text}</span>
        </button>
    );
};
